// Single source of truth for the Intercom workspace this app talks to.
// Hardcoded — same workspace as ClientConsole so support tickets land
// in the same inbox. If staging ever needs its own workspace, promote
// these to env vars and read from `getEnvironment()`.

export const INTERCOM_APP_ID = "v3rhqnn7"

export const INTERCOM_API_BASE = "https://api-iam.intercom.io"
